export default {
  created () {
    /** Handle steps */
    this.current_step_name = this.order_steps[0]
    /* Add step registration if the customer isn't registered */

    if (!this.is_connected) {
      this.$set(this.steps, 'accountRegistration', {
        icon: this.can_register ? 'user-edit' : 'sign-in-alt',
        name: this.can_register ? 'Créer un compte' : 'Se connecter',
        visited: false
      })
    }
  }
}
